import React, { useEffect, useState } from 'react'
import { Container,Row, Col, Tab, Nav } from 'react-bootstrap'
import Form from '../components/Form'
import { auth_delete, is_authenticated, set_redirect_after_authenticate_cache } from '../module/auth';
import { redirect, useLoaderData } from 'react-router-dom';
import { getDataProfile, get_activities_user } from '../api';
import FormProfile from '../components/forms/FormProfile';
import Table from '../components/Table';
import Pagination from '../components/Pagination';

export const loader = async(data) => {
    try{

        if(!is_authenticated()){
            
            set_redirect_after_authenticate_cache(data.request.url);
            return redirect("/login");
        }
        
        const response = await getDataProfile();
        return { data:response,error:null };
    }
    catch(err){

        if(err.status === 401){
            auth_delete();
            console.log("api send error authenticate",err)
            return redirect("/login");
        }
        return { data:null,error:err };
    }
}

function Profile() {

    const loader = useLoaderData();

    const [activities,set_activities] = useState([]);

    const onPage = async(pag) =>{
      console.log(pag);

      const act = await get_activities_user(pag);
      set_activities(()=>act);
    }

    useEffect(()=>{
      set_activities(()=>loader.data.list_of_activities);
    },[loader])

  return (
    <Container fluid>
        {/* <Row>
            <Col>
                <h3 className='text-center m-4'>Perfil de Usuario</h3>
            </Col>
        </Row> */}

        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
      <Row>
        <Col className='shadow bg-light pb-4' sm={3}>
            <h5 className='text-center m-4'>Perfil de Usuario</h5>
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="first">Datos Generles</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second">Historial de Activades</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={9} md='9'>
          <Tab.Content>
            <Tab.Pane eventKey="first">
               <Row className='justify-content-center'>
                    <h3 className='text-center mt-4 mb-4'>Datos Generles</h3>
                    <Col md={8} lg={8} xxl={8}>
                        <FormProfile loader={loader} />
                    </Col>
               </Row>
            </Tab.Pane>
            <Tab.Pane eventKey="second">
                <h3 className='text-center mt-4 mb-4'>Historial de Actividad</h3>
                <Row>

                <Col>
                    <p style={{float:"left"}}>Pag {activities.current_page + 1} de {activities.total_pages}</p>
                  </Col>

                  
                  <Col>
                    <Pagination current_pag={activities.current_page} total_pages={activities.total_pages} length={2} onPage={onPage} />
                  </Col>

                  <Col>
                    <p style={{float:"right"}}>Total registros {activities.total_records}</p>
                  </Col>
                 
                </Row>

                <Row>
                    <Col>
                        <Table source={activities.collection} />
                    </Col>
                </Row>
                <Row>

                  <Col>
                      <p style={{float:"left"}}>Pag {activities.current_page + 1} de {activities.total_pages}</p>
                    </Col>

                    
                    <Col>
                      <Pagination current_pag={activities.current_page} total_pages={activities.total_pages} length={2} onPage={onPage} />
                    </Col>

                    <Col>
                      <p style={{float:"right"}}>Total registros {activities.total_records}</p>
                    </Col>
                  
                  </Row>
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>

    </Container>
    

  )
}

export default Profile